<template>
  <div :class="{ 'version-header': true }">
    <div class="version-header-left">
      <Menu
        :menu="rightMenu"
        :cur-menu="curMenu"
      />
      <!-- <t-head-menu expand-type="popup" :value="curMenu">
        <t-submenu :title="$t('menuListCommonwealProject')">
          <t-menu-item
            v-for="(id, keys) in commonwealMenu"
            :key="keys"
            :value="id.path"
            :content="id.name"
            dt-eid="tab_link"
            @click="headleLink(id.path)"
            >{{ id.name }}</t-menu-item
          >
        </t-submenu>
        <t-menu-item @click="headleRouter('/news')">
          {{ $t('newsAndTrends') }}
        </t-menu-item>
      </t-head-menu> -->
    </div>
    <!-- {{ $t(menu) }} -->
    <div
      class="version-header-logo"
      @click="logo"
    >
      <img
        v-if="(!pageYOffset < 763 && isHome && direction) || (pageYOffset <= 763 && isHome)"
        src="~@/assets/imgs/logo/_logo_v2.png"
        alt=""
      />
      <img
        v-else
        src="~@/assets/imgs/logo/newA_logo_v2.png"
        alt=""
      />
    </div>
    <div class="version-header-right">
      <Menu
        :menu="leftMenu"
        :cur-menu="curMenu"
        @change-menu="changeMenu"
      />
      <!-- <t-head-menu expand-type="popup" :value="curMenu">
        <t-submenu :title="$t('menuListInformationTransparency')">
          <t-menu-item
            v-for="(id, keys) in informationMenu"
            :key="keys"
            :value="id.fullPath"
            :content="id.name"
            dt-eid="tab_link"
            @click="headleRouter(id.fullPath)"
            >{{ id.name }}</t-menu-item
          >
        </t-submenu>
        <t-submenu :title="$t('menuListAboutUs')">
          <t-menu-item
            v-for="(id, keys) in aboutMenu"
            :key="keys"
            :value="id.fullPath"
            :content="id.name"
            dt-eid="tab_link"
            @click="headleRouter(id.fullPath)"
            >{{ id.name }}</t-menu-item
          >
        </t-submenu>
      </t-head-menu> -->
      <div
        v-if="isHideLangAction"
        class="version-header-lang"
      >
        <template
          v-for="(item, key) in langMenu"
          :key="key"
        >
          <span
            :class="{ active: lang === key }"
            :dt-params="`lang=${key}`"
            dt-eid="language_bt"
            @click="handleChangeLang(key)"
            >{{ item }}</span
          >
          <span
            v-if="key === 'zh-CN'"
            :key="`line${key}`"
            :class="['slash-line', 'font48']"
            >|</span
          >
        </template>
      </div>
    </div>
  </div>
</template>
<script setup>
import { useRoute, useRouter } from 'vue-router';
import { ref, watch, onMounted, computed } from 'vue';
import { ABOUT_BAR, ABOUT_BAR_EN, INFOMATION_BAR } from '@/utils/routerConstant';
import Menu from '../Menu/index.vue';
import { reactive } from 'vue';
import { i18n, translateLang } from '@/utils/lang';
// 导入 useI18n
import { useI18n } from 'vue-i18n';

defineProps({
  pageYOffset: {
    type: Number,
    default: 0,
  },
  meta: {
    type: Object,
    default: () => ({}),
  },
  // 判断是否为首页
  isHome: {
    type: Boolean,
    default: false,
  },
  //
  direction: {
    type: Boolean,
    default: false,
  },
});

const route = useRoute();
const router = useRouter();
const { locale } = useI18n();
const langType = ref(localStorage.getItem('lang') || 'zh-CN');
const isCN = computed(() => langType.value === 'zh-CN');

// 监控语言切换，重新赋值语言类型
watch(
  () => locale.value,
  (nv) => {
    langType.value = nv;
  },
);

// 在 setup 中获取响应式的 t 函数
const { t } = useI18n();

const informationMenu = INFOMATION_BAR;
// const that = getCurrentInstance().appContext.config.globalProperties;

const commonwealMenuZH = [
  { name: '新基石研究员项目', fullPath: '/investigatorprogram' },
  { name: '科学探索奖', fullPath: '/xplorerprize' },
];
const commonwealMenuEN = [
  { name: 'New Cornerstone Investigator Program', fullPath: '/investigatorprogram' },
  { name: 'The Xplorer Prize', fullPath: '/xplorerprize' },
];
const academicMenuZH = [
  { name: '新基石研究员会议', fullPath: '/investigatormeeting' },
  { name: '新基石50²论坛', fullPath: '/forum' },
  { name: '新基石国际研讨会', fullPath: '/symposia' },
  { name: '新基石网络研讨会', fullPath: '/webinar' },
];
const academicMenuEN = [
  { name: 'New Cornerstone Investigator Meeting', fullPath: '/investigatormeeting' },
  { name: 'New Cornerstone Forum', fullPath: '/forum' },
  { name: 'New Cornerstone Symposia', fullPath: '/symposia' },
  // { name: 'webinar', fullPath: '/webinar' },
];

const visible = ref(false);
const curMenu = ref('');
const langMenu = reactive({ 'zh-CN': '中', 'en-US': 'EN' });

const lang = computed(() => i18n.global.locale.value);
watch(
  () => i18n.global.locale,
  (nv) => {
    lang.value = nv;
  },
  { deep: true },
);

const screenWidth = ref(window.innerWidth || document.documentElement.clientWidth);
const left = computed(() => {
  if (screenWidth.value > 1200 && isCN.value) {
    return 114;
  }
  if (screenWidth.value >= 1600 && !isCN.value) {
    return 130;
  }
  if (screenWidth.value < 1600 && screenWidth.value >= 1400 && !isCN.value) {
    return 100;
  }
  if (screenWidth.value < 1400 && screenWidth.value > 1200 && !isCN.value) {
    return 80;
  }
  if (screenWidth.value < 1200 && !isCN.value) {
    return 70;
  }
  // console.log('screenWidth.value', screenWidth.value);
  return 60;
});

const rightMenu = computed(() => {
  if (isCN.value) {
    return [
      {
        name: t('menuListCommonwealProject'),
        hasSubMenu: true,
        SubMenuList: commonwealMenuZH,
        left: left.value,
      },
      {
        name: t('menuListAcademicExchange'),
        hasSubMenu: true,
        SubMenuList: isCN.value ? academicMenuZH : academicMenuEN,
        left: left.value,
      },
      {
        name: t('newsAndTrends'),
        hasSubMenu: false,
        SubMenuList: null,
        fullPath: '/news',
        path: '/news',
      },
    ];
  }
  return [
    {
      name: t('menuListCommonwealProject'),
      hasSubMenu: true,
      SubMenuList: commonwealMenuEN,
      left: left.value,
    },
    {
      name: t('menuListAcademicExchange'),
      hasSubMenu: true,
      SubMenuList: isCN.value ? academicMenuZH : academicMenuEN,
      left: left.value,
    },
  ];
});

const leftMenu = computed(() => {
  if (isCN.value) {
    return [
      {
        name: t('menuListInformationTransparency'),
        hasSubMenu: true,
        SubMenuList: informationMenu,
        left: left.value,
      },
      {
        name: t('menuListAboutUs'),
        hasSubMenu: true,
        SubMenuList: ABOUT_BAR,
        left: left.value,
      },
    ];
  }
  return [
    {
      name: t('menuListAboutUs'),
      hasSubMenu: true,
      SubMenuList: ABOUT_BAR_EN,
    },
  ];
});
const isHideLangAction = computed(() => !route.meta.hideLangAction);

const changeMenu = (path) => {
  curMenu.value = path;
};

const logo = () => {
  visible.value = false;
  if (router.currentRoute.value === '/') {
    window.location.reload();
  } else {
    router.push('/');
  }
};

const handleChangeLang = (lang) => {
  translateLang(lang);
  console.log(lang);
};

onMounted(() => {
  const { pathname } = window.location;
  curMenu.value = pathname;
});

// const headleRouter = (path) => {
//   curMenu.value = path;
//   if (router.currentRoute.value.path !== path) {
//     router.push(path);
//   } else {
//     window.location.reload();
//   }
// };

watch(
  () => router.currentRoute.value.path,
  (toPath) => {
    // 要执行的方法
    const path1 = router.currentRoute.value.path;
    curMenu.value = path1;
  },
  { immediate: true, deep: true },
);
</script>
<style lang="scss" scoped>
@import './src/assets/styles/website';
</style>
